import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

// Cierre de sesion automatico: si el backend responde 401 (token caducado,
// invalido o usuario no encontrado — ver app/auth.py, token_required), no
// tiene sentido dejar la pantalla a medias con peticiones fallando en
// silencio. Interceptamos aqui TODAS las llamadas fetch de la app (no se
// usa axios en el proyecto) en un unico sitio, en vez de tocar cada fetch
// suelto de cada componente.
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401 && !window.location.pathname.startsWith('/login')) {
    localStorage.removeItem('token');
    localStorage.removeItem('rol');
    localStorage.removeItem('id');
    window.location.href = '/login';
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
